// React
import { BrowserRouter, Routes, Route } from "react-router-dom";

// Amplify
import { Amplify } from 'aws-amplify';

// Material UI
import { ThemeProvider } from '@emotion/react';
import { CssBaseline } from '@mui/material';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Grid from '@mui/material/Grid';

// Theme
import Theme from './Theme';

// Owned
import { Donations, Success, Cancel } from './Donations';
import Logo from './img/logo.png';
import awsconfig from './Config/aws-exports';

Amplify.configure(awsconfig);

function App() {
  return (
    <ThemeProvider theme={Theme}>
      <CssBaseline />
      <AppBar style={{ margin: 0 }}>
        <Toolbar style={{ margin: 0 }}>
          <IconButton edge="start" color="inherit" aria-label="menu">
            <a href='https://www.super-agent.com/'>
              <img src={Logo} height="30" alt="Super Agent" />
            </a>
          </IconButton>
        </Toolbar>
      </AppBar>
      <Grid container>
        <Grid item xs={12}>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Donations />} />
              <Route path="/success" element={<Success />} />
              <Route path="/cancel" element={<Cancel />} />
            </Routes>
          </BrowserRouter>
        </Grid>
      </Grid>
    </ThemeProvider>
  );
}

export default App;
